import { createReducer, INITIAL_STATE } from '../../../shared/redux';

const TOGGLE_ACCOUNT_ASSOCIATION_MODAL = 'TOGGLE_ACCOUNT_ASSOCIATION_MODAL';
const ACCOUNT_ASSOCIATION_MODAL_OPEN = 'ACCOUNT_ASSOCIATION_MODAL_OPEN';
const ACCOUNT_ASSOCIATION_MODAL_CLOSE = 'ACCOUNT_ASSOCIATION_MODAL_CLOSE';

export const toggleAccountAssociationModal = () => ({
    type: TOGGLE_ACCOUNT_ASSOCIATION_MODAL,
    payload: {},
});

export const openAssociationModal = () => ({
    type: ACCOUNT_ASSOCIATION_MODAL_OPEN,
    payload: {},
});

export const closeAssociationModal = () => ({
    type: ACCOUNT_ASSOCIATION_MODAL_CLOSE,
    payload: {},
});


const initialState = {
    isAccountAssociationModalOpen: false,
};

export const accountAssociationModalReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [TOGGLE_ACCOUNT_ASSOCIATION_MODAL]: state => ({
        ...state,
        isAccountAssociationModalOpen: !state.isAccountAssociationModalOpen,
    }),
    [ACCOUNT_ASSOCIATION_MODAL_OPEN]: state => ({
        ...state,
        isAccountAssociationModalOpen: true,
    }),
    [ACCOUNT_ASSOCIATION_MODAL_CLOSE]: state => ({
        ...state,
        isAccountAssociationModalOpen: false,
    }),
});
